import script from "./Share.vue?vue&type=script&setup=true&lang=js"
export * from "./Share.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__